//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import MenuIcon from '~/assets/img/menu.svg?inline'

export default {
  name: 'AppHeader',

  components: {
    MenuIcon
  },

  data() {
    return {
      showBag: false,
      showNav: false
    }
  },

  computed: {
    ...mapGetters('user', ['isSubscriber']),
    ...mapGetters('cart', ['bagCount'])
  },

  watch: {
    showBag(val) {
      if (val) {
        this.showNav = false
      }
    }
  },

  methods: {
    toggleNav() {
      this.showNav = !this.showNav
    },

    toggleBag() {
      this.showBag = !this.showBag
    }
  }
}
